import { isPlainObject } from '@util/utils';

export const checkResponse = (resp) => {
    return isPlainObject(resp) && resp.hasOwnProperty('isError') ? !resp.isError : true;
};
